// @flow

import { type PaginationType } from "@types";
import type { Client } from "@modules/client/types";
import type { ClientResponse } from "./types";

export type ClientModalState = $Exact<{
  showAddModal: boolean,
  showEditModal: boolean,
  showAddAdminAccountsModal: boolean,
  showAdditionalOptionsModal: boolean,
  showSelfServiceModal: boolean,
  showMainOptionsModal: boolean,
}>;

export type ClientList = $Exact<{
  content: ClientResponse[],
  pagination: PaginationType,
  totalElements: number,
}>;

export type ClientState = $Exact<{
  requestsInProgress: number,
  list: ClientList,
  current: Client | null,
  schema: Object | null,
  modals: ClientModalState,
}>;

export const initialState: ClientState = {
  requestsInProgress: 0,
  list: {
    content: [],
    pagination: {
      offset: 0,
      pageNumber: 0,
      pageSize: 0,
      sort: {
        orders: [],
      },
    },
    totalElements: 0,
  },
  current: null,
  schema: null,
  modals: {
    showAddModal: false,
    showEditModal: false,
    showAddAdminAccountsModal: false,
    showAdditionalOptionsModal: false,
    showSelfServiceModal: false,
    showMainOptionsModal: false,
  },
};

export default initialState;
